import L from "leaflet";

export const customMarker = new L.Icon({
    iconUrl: "/images/buku_tertutup.png",
    iconSize: [60, 60],
    iconAnchor: [20, 31],
    popupAnchor: [2, -40]
});
